import {Box, Grid} from "@mui/material";
import moment from "moment";
import commonStyles from "../commonStyles";

const STATUS_COLORS = {
    GREEN: '#2e7d32',
    YELLOW: '#ed6c02',
    RED: '#d32f2f',
    UNKNOWN: '#9e9e9e',
};

function resolveStatusColor(status) {
    const normalized = (status || '').toUpperCase();
    return STATUS_COLORS[normalized] || STATUS_COLORS.UNKNOWN;
}

function formatLastMessage(lastActivityDate, label) {
    if (!lastActivityDate) {
        return label.NO_MESSAGES;
    }
    return moment(lastActivityDate).format('DD MMM YYYY, HH:mm');
}

export default function TrendsSection({trendsHandle, label}) {
    const statusLabel = trendsHandle?.status || '-';
    const statusColor = resolveStatusColor(trendsHandle?.status);
    const lastMessage = formatLastMessage(trendsHandle?.lastActivityDate, label);

    return (
        <Box sx={styles.container}>
            <Box component={'h4'} sx={commonStyles.labelBold}>
                {label.TRENDS}
            </Box>
            <Grid container columnSpacing={4} rowSpacing={1}>
                <Grid item xs={12} md={4}>
                    <Box sx={commonStyles.labelMedium}>{label.STATUS}</Box>
                    <Box sx={styles.statusValue}>
                        <Box sx={{...styles.statusDot, backgroundColor: statusColor}} />
                        <Box component={'span'}>{statusLabel}</Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={8}>
                    <Box sx={commonStyles.labelMedium}>{label.LAST_MESSAGE}</Box>
                    <Box sx={styles.lastMessage}>{lastMessage}</Box>
                </Grid>
            </Grid>
        </Box>
    );
}

const styles = {
    container: {
        mb: 2,
    },
    statusValue: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mt: 0.5,
    },
    statusDot: {
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        display: 'inline-block',
    },
    lastMessage: {
        mt: 0.5,
    },
};
